import type { Theme } from '@mui/material';

export const styles = {
  chartBackgroundWrapper: {
    position: 'absolute',
    top: 0,
    left: '0.125rem',
    right: '0.125rem',
  },

  chartBackground: (theme: Theme) => ({
    height: '100%',
    width: '100%',

    [theme.breakpoints.up('md')]: {
      pl: '4rem',
    },
  }),

  valueIndicator: (theme: Theme) => ({
    width: '100%',
    height: '10%',
    borderTop: `1px solid ${theme.colors.neutral[200]}`,
    position: 'relative',
    px: 0.25,
  }),

  labelY: (theme: Theme) => ({
    display: 'none',

    [theme.breakpoints.up('md')]: {
      display: 'block',
      color: theme.colors.neutral[600],
      fontWeight: 600,
      fontSize: '14px',
      position: 'absolute',
      textAlign: 'right',
      left: '-4.5rem',
      top: '-0.75rem',
      minWidth: '3rem',
    },
  }),
};
